import { createI18n } from 'vue-i18n'
import en from './en.json'
import ru from './ru.json'

const messages = {
  en,
  ru
} as const

const isClient = typeof window !== 'undefined'
const initialLocale = isClient ? window.localStorage.getItem('userLocale') ?? 'en' : 'en'

/**
 * Русские формы множественного числа: `1 товар | 2 товара | 5 товаров`.
 * Без этого правила vue-i18n берёт английское «один / не один» и на 2–4
 * выбирает форму для «много» — что уже ломало `items_found`.
 */
function russianPluralIndex(choice: number, choicesLength: number): number {
  if (choicesLength < 3) {
    return choice === 1 ? 0 : 1
  }

  const mod10 = choice % 10
  const mod100 = choice % 100

  if (mod10 === 1 && mod100 !== 11) return 0
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 1
  return 2
}

export const i18n = createI18n({
  legacy: false, // для Composition API
  locale: initialLocale, // язык по умолчанию
  fallbackLocale: 'en', // резервный язык
  messages,
  pluralRules: {
    ru: russianPluralIndex
  }
})

export const availableLocales = Object.keys(messages) as Array<keyof typeof messages>